<template>
  <div class="pagination-container">
    <nav class="flex items-center space-x-2">
      <!-- 上一页按钮 -->
      <button
        class="page-btn"
        :disabled="page_current <= 1"
        @click="handlePrevPage"
      >
        <i class="ri-arrow-left-line"></i>
      </button>

      <!-- 页码显示 -->
      <template v-if="totalPages > 0">
        <!-- 第一页 -->
        <button v-if="startPage > 1" class="page-num" @click="goToPage(1)">
          1
        </button>

        <!-- 省略号 -->
        <span v-if="startPage > 2" class="page-ellipsis">...</span>

        <!-- 中间页码 -->
        <button
          v-for="page in visiblePages"
          :key="page"
          class="page-num"
          :class="{ active: page === page_current }"
          @click="goToPage(page)"
        >
          {{ page }}
        </button>

        <!-- 省略号 -->
        <span v-if="endPage < totalPages - 1" class="page-ellipsis">...</span>

        <!-- 最后一页 -->
        <button
          v-if="endPage < totalPages"
          class="page-num"
          @click="goToPage(totalPages)"
        >
          {{ totalPages }}
        </button>
      </template>

      <!-- 下一页按钮 -->
      <button
        class="page-btn"
        :disabled="page_current >= totalPages"
        @click="handleNextPage"
      >
        <i class="ri-arrow-right-line"></i>
      </button>

      <!-- 页码信息 -->
      <div class="page-info">
        第 <span class="current-page">{{ page_current }}</span> /
        {{ totalPages }} 页
        <span class="separator">|</span>
        共 <span class="total-count">{{ totalCount }}</span> 条记录
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    totalCount: {
      type: Number,
      default: 0,
    },
    page_current: {
      type: Number,
      default: 1,
    },
    page_size: {
      type: Number,
      default: 10,
    },
    visibleRange: {
      type: Number,
      default: 2,
    },
  },
  computed: {
    totalPages: function () {
      return Math.max(1, Math.ceil(this.totalCount / this.page_size));
    },
    startPage: function () {
      var start = Math.max(1, this.page_current - this.visibleRange);
      return Math.min(
        start,
        Math.max(1, this.totalPages - this.visibleRange * 2)
      );
    },
    endPage: function () {
      var end = Math.min(
        this.totalPages,
        this.page_current + this.visibleRange
      );
      return Math.max(
        end,
        Math.min(this.totalPages, this.visibleRange * 2 + 1)
      );
    },
    visiblePages: function () {
      var pages = [];
      for (var i = this.startPage; i <= this.endPage; i++) {
        pages.push(i);
      }
      return pages;
    },
  },
  methods: {
    goToPage: function (page) {
      if (page !== this.page_current && page >= 1 && page <= this.totalPages) {
        this.$emit("page-change", page);
      }
    },
    handlePrevPage: function () {
      if (this.page_current > 1) {
        this.goToPage(this.page_current - 1);
      }
    },
    handleNextPage: function () {
      if (this.page_current < this.totalPages) {
        this.goToPage(this.page_current + 1);
      }
    },
  },
};
</script>

<style scoped>
.pagination-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2rem;
}

.page-btn {
  padding: 0.75rem 0.75rem;
  color: #6b7280;
  transition: color 0.2s;
}

.page-btn:hover {
  color: #3b82f6;
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-btn:disabled:hover {
  color: #6b7280 !important;
}

.page-num {
  padding: 0.75rem 0.75rem;
  color: #4b5563;
  transition: all 0.2s;
}

.page-num:hover {
  color: #3b82f6;
}

.page-num.active {
  background-color: #3b82f6;
  color: white;
  border-radius: 0.375rem;
}

.page-ellipsis {
  padding: 0.75rem 0.75rem;
  color: #6b7280;
}

.page-info {
  margin-left: 1.5rem;
  font-size: 0.875rem;
  color: #6b7280;
}

.current-page,
.total-count {
  color: #3b82f6;
  font-weight: 500;
}

.separator {
  margin: 0 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue